// Dependencies
require("./bootstrap");

import * as Sentry from "@sentry/browser";
import ApexCharts from 'apexcharts'

import Cookies from "js-cookie";
import Dashboard from "./dashboard";
import Notificaciones from "./notificaciones";
import FormHelper from "./form_helper";
import UIIdleTimeout from "./ui_idle_timeout";
import Paginacion from "./paginacion";
import Login from "./login";
import Roles from "./roles";
import Permisos from "./permisos";
import Usuarios from "./usuarios";

import CargasExternas from "./cargas_externas";
import InternalJobs from "./internal_jobs";
import CuentaCorriente from "./cuenta_corriente";
import Empresas from "./empresas";
import Manifiestos from "./manifiestos";
import Di from "./di";
import DocumentosBase from "./documentos_base";
import ReportesSql from "./reportes_sql";
import RelojControl from "./reloj_control";
import CrawlerCredential from "./crawler_credential";

// Sentry Error Reporting
window.Sentry = Sentry;

// ApexCharts
window.ApexCharts = ApexCharts;

// Base modules
window.Dashboard = Dashboard;
window.Notificaciones = Notificaciones;
window.FormHelper = FormHelper;
window.UIIdleTimeout = UIIdleTimeout;
window.Paginacion = Paginacion;
window.Login = Login;
window.Roles = Roles;
window.Permisos = Permisos;
window.Usuarios = Usuarios;

// App
window.Empresas = Empresas;
window.Manifiestos = Manifiestos;
window.Di = Di;
window.CargasExternas = CargasExternas;
window.InternalJobs = InternalJobs;
window.CuentaCorriente = CuentaCorriente;
window.DocumentosBase = DocumentosBase;
window.ReportesSql = ReportesSql;
window.Cookies = Cookies;
window.RelojControl = RelojControl;
window.CrawlerCredential = CrawlerCredential;
